var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lang-list" },
    _vm._l(_vm.languages, function(lang, idx) {
      return _c(
        "a",
        {
          key: idx,
          staticClass: "u-reset lang-list--link",
          attrs: { href: lang.path }
        },
        [_vm._v("\n        " + _vm._s(lang.label) + "\n    ")]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a69ead1", { render: render, staticRenderFns: staticRenderFns })
  }
}